import { history } from 'umi'

interface urlParams {
  url?: string
  href?: string
}

// 如果value是字符串用'push'|'replace'  如果是number用 'go'|'goBack'
type BackType = 'go' | 'goBack'
type GoType = 'push' | 'replace'

interface Params {
  type?: GoType | GoType
  urlKey?: 'url' | 'href'
  isGo?: boolean
  useMasterHistory?: boolean
  time?: number // 多少毫秒后执行
}
/**
 * @params 第二个参数 @param {object}
 *    type 内部跳转的类型  push/replace
 *    urlKey url的key值
 *    code
 *    isGo 是否跳转， false的话获取url不跳转
 *    masterHistory 为true 则会使用父级路由window.masterHistory
 *
 * @urlParams 第一个参数 @param {object|string}
 *    @param {string}
 *    a、没有http的内部跳转，umi上的history, 如果params有带masterHistory 则会使用父级路由window.masterHistory
 *    b、带了http的正常url, window.location.href = url
 *
 *    @param {object} 如果是obj的
 *    初始url urlParams[urlKey]
 */
interface GoToFn {
  (urlParams: string | number | urlParams, params?: Params): void
}

const goTo: GoToFn = async (
  urlParams: string | number | urlParams,
  params = {},
) => {
  params = {
    urlKey: 'url',
    time: undefined,
    ...params,
  } as Params
  const typeUrl = typeof urlParams
  const isString = typeUrl === 'string'
  const isTypeNum = typeUrl === 'number'
  const defaultType = isTypeNum ? 'goBack' : 'push'
  const { useMasterHistory = true, time } = params
  const masterHistory = useMasterHistory && window.masterHistory
  let type = params.type || defaultType
  const urlKey = params.urlKey!
  // 如果是数字就是返回
  if (isTypeNum) {
    const numUrl = urlParams as number
    onGo(() => {
      masterHistory && window?.masterHistory[type as BackType](numUrl)
      // 正常history 跳转
      !masterHistory && history[type as BackType](numUrl)
    }, time)
    return
  }
  // 如果传过来是个字符串并且不含有http字眼
  const _urlParams = urlParams as urlParams // 这个只是为了强制定义成urlParams
  let url = (isString ? urlParams : _urlParams[urlKey]) as string
  const hasHttp = url.startsWith('http')
  const isNeedBrowerSkip = url.startsWith('weixin')
  // 如果是字符串或者url没有https
  if (!hasHttp && !isNeedBrowerSkip) {
    // 若是启用父级路由先判断有没有，没有则不作为
    onGo(() => {
      masterHistory && window.masterHistory[type as GoType](url)
      // 正常history 跳转
      !masterHistory && history[type as GoType](url)
    }, time)
  } else {
    onGo(() => {
      windowGoUrl(url, type)
    }, time)
  }
  return url
}

const onGo = (callback: Function, time?: number) => {
  if (time !== undefined) {
    setTimeout(callback, time)
  } else {
    callback()
  }
}

export const windowGoUrl = (url: string, type: string) => {
  if (type === 'replace') {
    location.replace(url)
    return
  }
  return (window.location.href = url)
}

export default goTo
